import * as React from "react";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  tooltipContentVariants,
} from "@/components/ui/tooltip";
import type { VariantProps } from "class-variance-authority";

type TooltipIconButtonProps = Omit<
  React.ComponentProps<typeof Button>,
  "variant"
> & {
  variant?: React.ComponentProps<typeof Button>["variant"];
  label: React.ReactNode;
  side?: React.ComponentProps<typeof TooltipContent>["side"];
  sideOffset?: React.ComponentProps<typeof TooltipContent>["sideOffset"];
  tooltipVariant?: VariantProps<typeof tooltipContentVariants>["variant"];
  "aria-label"?: string;
};

function TooltipIconButton({
  label,
  side,
  sideOffset,
  tooltipVariant,
  variant = "ghost",
  size = "icon-sm",
  "aria-label": ariaLabel,
  children,
  ...props
}: TooltipIconButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant={variant}
          size={size}
          aria-label={
            ariaLabel ?? (typeof label === "string" ? label : undefined)
          }
          {...props}
        >
          {children}
        </Button>
      </TooltipTrigger>
      <TooltipContent
        side={side}
        sideOffset={sideOffset}
        variant={tooltipVariant}
      >
        {label}
      </TooltipContent>
    </Tooltip>
  );
}

export { TooltipIconButton };
